/*eslint-disable*/
import React from 'react';
// chakra imports
import { Link } from 'react-router-dom';
import {
  Box,
  useColorMode,
  useColorModeValue,
  Show,
  Hide,
} from '@chakra-ui/react';

import Logo from '../../assets/logo.png';
import LogoLight from '../../assets/logo-light.png';

import Items from './Items';

const Sidebar = ({ routes }) => {
  const { colorMode, toggleColorMode } = useColorMode();

  const bgColor = useColorModeValue('white.primary', 'blue.primary');

  return (
    <Show above="md">
      <Box
        w={{ xl: '15%', lg: '15%', md: '0%', sm: '0%' }}
        height="100%"
        bg={bgColor}
        px="5"
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Link to={'/'}>
            <img
              src={colorMode == 'light' ? LogoLight : Logo}
              alt=""
              style={{
                width: 50,
                marginBottom: 20,
                marginTop: 20,
              }}
              onClick={() => toggleColorMode()}
            />
          </Link>
        </div>
        <Items routes={routes} />
      </Box>
    </Show>
  );
};

export default Sidebar;
